import styled from 'styled-components'

const ModalContainer = styled.div`
  .modal * {
    z-index: auto !important;
  }
  input {
    outline: none;
  }
`

export {
  ModalContainer
}
